import { connect } from 'react-redux'
import Gender from './Gender.jsx'
import { getCollaborativeIndexationCreationFields } from '../../../../../../redux/collaborativeIndexations/selectors'
import { updateCollaborativeIndexationFieldValue } from '../../../../../../redux/collaborativeIndexations/actions'

const mapDispatchToProps = dispatch => ({
    updateFieldValue: (field, value) => dispatch(updateCollaborativeIndexationFieldValue(field, value)),
})

const mapStateToProps = state => ({
    fields: getCollaborativeIndexationCreationFields(state),
})

export const GenderContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Gender)
